import { connect } from 'react-redux';
import DeliveryDialog from './delivery-dialog';
import { selectOrderForDeliveryInfo } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  open: !!state.orders.selectedOrderForDeliveryInfo,
  order: state.orders.selectedOrderForDeliveryInfo,
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(selectOrderForDeliveryInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDialog);
